import { registerRegisterDetail } from '@/features/startTask/preset_task/shared/preset/register/registerDetailRegistry';

registerRegisterDetail('B32006', {
  title: 'Transfer of Shares',
  repeatArrayPath: 'shareholders',
  repeatTabLabelOverride: 'Transfer',
  fields: [
    { label: 'Entity Name', key: ['entityName', 'companyName'] },
    { label: 'Entity UEN', key: ['entityRegNo', 'companyRegistrationNo'] },
    { label: 'Transaction Date', key: ['transactionDate'] },
    { label: 'Transferor', key: ['shareholders.0.fromShareholderName', 'fromShareholderName'] },
    { label: 'Transferee', key: ['shareholders.0.toShareholderName', 'toShareholderName'] },
    { label: 'Shares', key: ['shareholders.0.fromNumberOfShares', 'fromNumberOfShares'] },
    { label: 'Class', key: ['shareholders.0.shareTypeName', 'shareTypeName'] },
  ],
});
